import { gql } from "@apollo/client";

export const DeleteInstalledBaseRegionSubscription = gql`
    mutation DeleteInstalledBaseRegionSubscription ($id: ID!) {
        deleteInstalledBaseRegionSubscription(id: $id) {
            success
            message
        }
    }
`;
